<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">绑定</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode"
                           @change="insChange" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item" >
              <el-form-item label="床位号" required prop="berthCode">
                <el-cascader
                    v-model="addForm.berthCode"
                    placeholder="请选择床位"
                    :options="ListRoom" :props="props" style="width:100%"></el-cascader>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="设备号" required prop="imei">
                <el-input v-model="addForm.imei" placeholder="请输入设备号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="地点" required prop="placeName">
                <el-input v-model="addForm.placeName" placeholder="请输入地点"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="设备类型" required prop="deviceType">
                <el-select v-model="addForm.deviceType" placeholder="请选择设备类型" style="width: 100%">
                  <el-option
                      v-for="item in type_arr"
                      :key="item.val"
                      :label="item.name"
                      :value="item.val">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import {getStaffCode,getGovernmentCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {
      loading: false,


      ListRoom:[],

      addForm:{
        timeStr:timeStr,
        sign:'',
        governmentCode:getGovernmentCode(),

        imei:'',
        institutionCode:'',
        placeName:'',
        deviceType:'',

        berthCode:'',
        berthInfo:'',

        userCode:'',

      },

      type:'',
      type_arr:[
        //{val:1, name:'清雷'},
        {val:2, name:'驰通达4G'},
        {val:3, name:'欧万'},
        {val:4, name:'睡倍健'},
        {val:5, name:'驰通达WIFI'},
      ],

      rules:{
        imei:[
          { required: true, message: '请输入设备号', trigger: 'blur' },
        ],
        deviceType:[
          { required: true, message: '选择设备类型', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请选择老人', trigger: 'blur' }
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' }
        ],
        placeName:[
          { required: true, message: '请输入地点', trigger: 'blur' },
        ],
        berthCode:[
          { required: true, message: '请选择床位', trigger: 'blur' },
        ],
      },

      props: {
        emitPath:false,
        value: 'value',
        label: 'label',
        children: 'children'
      },


    }
  },
  components: {

  },
  methods: {
    init(type){
      this.type = type;
      this.$refs.addForm.resetFields();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);


      let userCode = "";
      let berthInfo = "";
      for(let i=0;i<this.ListRoom.length;i++){
        let listRoom = this.ListRoom[i].children;
        for(let j=0;j<listRoom.length;j++){
          let listBerth = listRoom[j].children;
          for(let k=0;k<listBerth.length;k++){
            if(listBerth[k].value == this.addForm.berthCode){
              berthInfo = this.ListRoom[i].label+'-'+listRoom[j].label+'-'+listBerth[k].label;
              userCode = listBerth[k].checkinUserCode;
            }
          }

        }
      }

      //console.log(berthInfo);

      this.addForm.berthInfo = berthInfo;
      this.addForm.userCode = userCode;


      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceQLSign/InsAddRoom",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },

    insChange(val){
      this.addForm.institutionCode = val;

      this.ListRoom = [];

      this.addForm.berthCode = '';

      this.getBerth();
    },
    getBerth:function (){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Berth/GovInsListAll",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.addForm.institutionCode,
        }
      }).then((response) => {
            //console.log(response);
            if (response.data.error == 0) {

              var datas=response.data.data

              var JSONData=JSON.stringify(datas);
              JSONData=JSONData.replace(/listRoomDTO/g,'children');
              JSONData=JSONData.replace(/listBerthDTO/g,'children');
              JSONData=JSONData.replace(/name/g,'label');
              JSONData=JSONData.replace(/number/g,'label');

              //var list=this.getListBerth(JSON.parse(JSONData),0)
              //JSONData=JSON.stringify(list);

              //JSONData=JSONData.replace(/buildingCode/g,'value');
              //JSONData=JSONData.replace(/roomCode/g,'value');
              JSONData=JSONData.replace(/berthCode/g,'value');

              //console.log(JSONData);
              this.ListRoom=JSON.parse(JSONData);

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },



  }
}


</script>


<style lang="scss" scoped>

</style>
